/**
 * Extract user alias from username for profile picture URL
 */
export const extractUserAlias = (username: string): string | null => {
  if (!username) return null;

  // Remove email domain if present
  const cleanUsername = username.split('@')[0];

  // Handle AmazonFederate_ prefix
  if (cleanUsername.startsWith('AmazonFederate_')) {
    return cleanUsername.replace('AmazonFederate_', '');
  }

  // If it contains a dot, assume it's lastname.firstname format
  if (cleanUsername.includes('.')) {
    const parts = cleanUsername.split('.');
    if (parts.length === 2) {
      const [lastname, firstname] = parts;
      return `${firstname.substring(0, 2)}${lastname}`;
    }
  }

  return cleanUsername;
};

/**
 * Generate user profile picture URL
 */
export const getUserProfilePictureUrl = (alias: string): string => {
  return `https://badgephotos.corp.amazon.com/?uid=${alias}`;
};

/**
 * Get user initials as fallback
 */
export const getUserInitials = (username: string): string => {
  if (!username) return 'U';

  const cleanUsername = username.replace('AmazonFederate_', '');

  if (cleanUsername.includes('.')) {
    const parts = cleanUsername.split('.');
    return parts.map((part) => part.charAt(0).toUpperCase()).join('');
  }

  return cleanUsername.charAt(0).toUpperCase();
};
